import * as React from "react";
const IconMessageCheck = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="m59.2 42.2-8.4 8.2c-.7.7-1.9.7-2.6 0l-4.7-4.6c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l4.7 4.6c.7.7 1.7 1.1 2.7 1.1s1.9-.4 2.7-1.1l8.4-8.2c.4-.4.4-1 0-1.4-.3-.4-1-.4-1.4 0" />
    <path d="M56.9 11.1H7.1c-2.8 0-5.1 2.3-5.1 5.1v31.4c0 2.8 2.3 5.1 5.1 5.1h27.6c.6 0 1-.4 1-1s-.4-1-1-1H7.1c-1.7 0-3.1-1.4-3.1-3.1V16.1c0-.4.1-.8.2-1.1l25 15.2c.9.5 1.8.8 2.8.8s1.9-.3 2.8-.8l25-15.2c.1.3.2.7.2 1.1v14.4c0 .6.4 1 1 1s1-.4 1-1V16.1c0-2.8-2.3-5-5.1-5M33.8 28.5c-1.1.7-2.4.7-3.5 0l-24.7-15c.5-.3 1-.4 1.6-.4H57c.6 0 1.1.2 1.6.4z" />
  </svg>
);
export default IconMessageCheck;
